import { css } from 'styled-components';
import { COLORS } from '../../design/tokens';
// TODO: Remove colors from sizes
const styles = {
  container: css`
    text-align: ${props => props.align};
  `,
  small: css`
    text-transform: ${({uppercase}) => uppercase ? 'uppercase' : 'initial'};
    color: ${props => props.color || COLORS.TEXT.LIGHT_GRAY};
    font-weight: ${props => props.weight || '400'};
    font-family: ${props => props.font || `'Open Sans', sans-serif`};
    font-size: 14px;
  `,
  normal: css`
    text-transform: ${({uppercase}) => uppercase ? 'uppercase' : 'initial'};
    color: ${props => props.color || COLORS.TEXT.BLACK};
    font-weight: ${props => props.weight || '400'};
    font-family: ${props => props.font || `'Open Sans', sans-serif`};
    font-size: 16px;
  `,
  large: css`
    text-transform: ${({uppercase}) => uppercase ? 'uppercase' : 'initial'};
    color: ${props => props.color || COLORS.TEXT.BLACK};
    font-weight: ${props => props.weight || '900'};
    font-family: ${props => props.font || `'Open Sans', sans-serif`};
    font-size: 20px;
  `,
  xlarge: css`
    text-transform: ${({uppercase}) => uppercase ? 'uppercase' : 'initial'};
    color: ${props => props.color || COLORS.TEXT.BLACK};
    font-weight: ${props => props.weight || '900'};
    font-family: ${props => props.font || `'Open Sans', sans-serif`};
    font-size: 32px;
  `,
  title: css`
    text-transform: ${({uppercase}) => uppercase ? 'uppercase' : 'initial'};
    color: ${props => props.color || COLORS.TEXT.SEA_BLUE};
    font-weight: ${props => props.weight || '900'};
    font-family: ${props => props.font || `'Open Sans', sans-serif`};
    font-size: 48px;
    letter-spacing: 1.8px;
  `,
  placeholder: css`
    text-transform: ${({uppercase}) => uppercase ? 'uppercase' : 'initial'};
    color: ${props => props.color || COLORS.TEXT.LIGHT_GRAY};
    font-family: ${props => props.font || `'Open Sans', sans-serif`};
    font-size: 16px;
    line-height: 24px;
  `
};

const brStyles = {
  small: css`
    line-height: ${({lines}) =>  `${lines * 14}px`};
  `,
  normal: css`
    line-height: ${({lines}) =>  `${lines * 16}px`};
  `,
  large: css`
    line-height: ${({lines}) =>  `${lines * 20}px`};
  `,
  xlarge: css`
    line-height: ${({lines}) =>  `${lines * 30}px`};
  `,
  title: css`
    line-height: ${({lines}) =>  `${lines * 48}px`};
  `
};

export {
  styles,
  brStyles
}

export default styles;
